import { Typography } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.ul `
  list-style: none;
`;
export const UppercaseText = styled(Typography) `
  text-transform: uppercase;
`;
